module.exports = __webpack_public_path__ + "img/oneSignal_help.082839b0.jpg";